export default "__VITE_ASSET__BLofEul4__"